export type WeaponId =
  | 'shell'
  | 'heavy'
  | 'grenade'
  | 'cluster'
  | 'digger'
  | 'dirt'
  | 'airstrike'
  | 'nuke'
  | 'napalm'
  | 'banana'
  | 'laser'
  | 'roller'
  | 'teleport'
  | 'guided'
  | 'shotgun'
  | 'bunker'
  | 'sheep'
  | 'mine'
  | 'quake'
  | 'blackhole'
  | 'lightning'
  | 'kamikaze'
  | 'bazuka'
  | 'bomber';

/** Druh letícího objektu – zbraň nebo její „potomek“. */
export type ProjectileKind = WeaponId | 'airbomb' | 'flame' | 'pellet' | 'bomberplane';

export interface WeaponDef {
  id: WeaponId;
  name: string;
  icon: string;
  /** Počáteční munice, -1 = neomezeně. */
  ammo: number;
  radius: number;
  damage: number;
  description: string;
}

export const WEAPONS: Record<WeaponId, WeaponDef> = {
  shell: { id: 'shell', name: 'Střela', icon: '●', ammo: -1, radius: 30, damage: 40, description: 'Obyčejný granát. Nikdy nedojde.' },
  heavy: { id: 'heavy', name: 'Těžká střela', icon: '⬤', ammo: 3, radius: 55, damage: 60, description: 'Velký kráter, velké škody.' },
  grenade: { id: 'grenade', name: 'Granát', icon: '◉', ammo: 3, radius: 42, damage: 50, description: 'Odráží se a vybuchne po 3 s.' },
  cluster: { id: 'cluster', name: 'Kazeta', icon: '⁂', ammo: 2, radius: 24, damage: 25, description: 'Ve vrcholu dráhy se rozpadne na 5 bombiček.' },
  digger: { id: 'digger', name: 'Vrták', icon: '➶', ammo: 2, radius: 13, damage: 12, description: 'Provrtá tunel skrz terén.' },
  dirt: { id: 'dirt', name: 'Hlína', icon: '▲', ammo: 2, radius: 48, damage: 0, description: 'Nasype kopec hlíny. Zakopej soupeře!' },
  airstrike: { id: 'airstrike', name: 'Letecký úder', icon: '✈', ammo: 1, radius: 26, damage: 28, description: 'Označí cíl – shora na něj spadne řada 5 bomb.' },
  nuke: { id: 'nuke', name: 'Atomovka', icon: '☢', ammo: 1, radius: 110, damage: 95, description: 'Obrovský kráter a zničující výbuch.' },
  napalm: { id: 'napalm', name: 'Napalm', icon: '♨', ammo: 2, radius: 14, damage: 10, description: 'Hořící kapky stečou z kopce a pálí tanky.' },
  banana: { id: 'banana', name: 'Banánová bomba', icon: '☾', ammo: 1, radius: 30, damage: 30, description: 'Vybuchne a rozhodí 5 banánů, každý vybuchne znovu.' },
  laser: { id: 'laser', name: 'Laser', icon: '⚡', ammo: 1, radius: 5, damage: 40, description: 'Letí rovně skrz terén i tanky, nezajímá ho vítr.' },
  roller: { id: 'roller', name: 'Válec', icon: '◍', ammo: 2, radius: 38, damage: 45, description: 'Po dopadu se kutálí z kopce a vybuchne u tanku.' },
  teleport: { id: 'teleport', name: 'Teleport', icon: '✦', ammo: 2, radius: 0, damage: 0, description: 'Přenese tvůj tank na místo dopadu.' },
  shotgun: { id: 'shotgun', name: 'Brokovnice', icon: '⁖', ammo: 2, radius: 5, damage: 12, description: '6 broků ve vějíři – silná zblízka, na dálku slabá.' },
  bunker: { id: 'bunker', name: 'Bunker buster', icon: '⛏', ammo: 2, radius: 40, damage: 55, description: 'Prorazí 80 px terénu a vybuchne uvnitř.' },
  sheep: { id: 'sheep', name: 'Ovce', icon: '🐑', ammo: 1, radius: 45, damage: 55, description: 'Běží po terénu, přeskakuje překážky a u tanku vybuchne.' },
  mine: { id: 'mine', name: 'Mina', icon: '✹', ammo: 3, radius: 34, damage: 45, description: 'Zůstane na mapě a vybuchne, když k ní někdo dojede.' },
  quake: { id: 'quake', name: 'Zemětřesení', icon: '〰', ammo: 1, radius: 15, damage: 12, description: 'Otřese celou mapou – sesuvy všude a škoda všem tankům.' },
  blackhole: { id: 'blackhole', name: 'Černá díra', icon: '◉', ammo: 1, radius: 60, damage: 50, description: 'Pohltí terén a přitáhne tanky k sobě.' },
  lightning: { id: 'lightning', name: 'Blesk', icon: 'ϟ', ammo: 2, radius: 18, damage: 45, description: 'Udeří svisle z nebe – zasáhne i tank pod převisem.' },
  guided: { id: 'guided', name: 'Řízená střela', icon: '🎯', ammo: 2, radius: 34, damage: 50, description: 'Za letu ji řídíš šipkami ← → (na mobilu tlačítky).' },
  kamikaze: { id: 'kamikaze', name: 'Kamikadze dron', icon: '🚁', ammo: 1, radius: 42, damage: 60, description: 'FPV dron: řídíš ho z jeho kamery, umí se zastavit ve vzduchu a vybuchne při nárazu nebo na povel.' },
  bazuka: { id: 'bazuka', name: 'Bazuka', icon: '🚀', ammo: 3, radius: 38, damage: 55, description: 'Rychlá raketová střela s kouřovou stopou a přímou dráhou letu.' },
  bomber: { id: 'bomber', name: 'Bombardér', icon: '🛩️', ammo: 1, radius: 36, damage: 50, description: 'Leť v roli bombometčíka nad mapou, zamiř bombardovacím zaměřovačem a shazuj bomby!' },
};

/** Munice tanku (starší hry nemají nové zbraně → výchozí množství). */
export function ammoOf(ammo: Partial<Record<WeaponId, number>>, weapon: WeaponId): number {
  return ammo[weapon] ?? WEAPONS[weapon].ammo;
}

export const WEAPON_IDS = Object.keys(WEAPONS) as WeaponId[];

export const GRENADE_FUSE = 3;
export const CLUSTER_COUNT = 5;
export const DIGGER_STEPS = 8;
export const DIGGER_SPACING = 11;

export const AIRSTRIKE_BOMBS = 5;
export const AIRSTRIKE_SPACING = 26;
export const BANANA_COUNT = 5;

export const BOMBER_SPEED = 280;
export const BOMBER_ALTITUDE = -35;
export const BOMBER_BOMBS = 5;
export const BOMBER_COOLDOWN = 0.35;
export const BOMBER_MAX_STEPS = 1000;
export const BOMBER_MAX_RUNS = 80;
export const BANANA_RADIUS = 32;
export const BANANA_DAMAGE = 30;
export const NAPALM_FLAMES = 10;
export const NAPALM_BURN = 3.2;
export const NAPALM_FLOW = 40;
export const NAPALM_DPS = 14;
export const FLAME_R = 12;
export const LASER_SPEED = 1800;
export const LASER_RANGE = 1400;
export const LASER_CARVE_EVERY = 8;
export const ROLLER_TIME = 4;

/** Řízená střela: konstantní rychlost, otáčení šipkami, po vyčerpání paliva padá. */
export const GUIDED_SPEED = 380;
export const GUIDED_FUEL = 6;
/** Otočení za jeden simulační krok: 160 °/s × 1/240 s. Literály, aby výsledek nezávisel na Math.cos/sin enginu. */
export const GUIDED_COS = 0.9999323080037622;
export const GUIDED_SIN = 0.011635265801397014;
export const GUIDED_MAX_STEPS = 16 * 240;
export const GUIDED_MAX_RUNS = 2000;

/**
 * Kamikadze dron: létá ve 3D jako průzkumný dron (plyn, otáčení, dopředu, úkrok),
 * umí viset ve vzduchu, po vybití baterie padá.
 */
export const KAMIKAZE_SPEED = 150;
export const KAMIKAZE_STRAFE = 110;
export const KAMIKAZE_CLIMB = 110;
export const KAMIKAZE_LAUNCH = 120;
/** Jak rychle dron dosáhne požadované rychlosti (1/s). */
export const KAMIKAZE_RESPONSE = 2.5;
export const KAMIKAZE_FUEL = 12;
export const KAMIKAZE_MAX_STEPS = 24 * 240;
/** Záznam řízení smí mít až tolik úseků, kolik je kroků (analogové páčky mění povel často). */
export const KAMIKAZE_MAX_RUNS = KAMIKAZE_MAX_STEPS;
/** Otočení za krok: 1,8 rad/s × 1/240 s (plná páka) a polovina. Literály kvůli determinismu. */
export const KAMIKAZE_TURN_COS = 0.9999718751318357;
export const KAMIKAZE_TURN_SIN = 0.0074999296876977544;
export const KAMIKAZE_TURN_COS_HALF = 0.9999929687582397;
export const KAMIKAZE_TURN_SIN_HALF = 0.00374999121094368;
/** Počet povelů: 4 osy × 5 úrovní (−1, −½, 0, ½, 1). */
export const KAMIKAZE_CODES = 625;

export const SHOTGUN_PELLETS = 6;
export const SHOTGUN_SPREAD = 9;
export const SHOTGUN_LIFE = 1.2;
export const BUNKER_SPEED = 600;
export const BUNKER_DEPTH = 80;
export const SHEEP_SPEED = 70;
export const SHEEP_TIME = 5;
export const MINE_TRIGGER = 18;
export const QUAKE_DAMAGE = 12;
export const QUAKE_DURATION = 1.6;
export const BLACKHOLE_RANGE = 220;
export const BLACKHOLE_DURATION = 2;
export const LIGHTNING_WIDTH = 16;

export function initialAmmo(): Record<WeaponId, number> {
  const a = {} as Record<WeaponId, number>;
  for (const id of WEAPON_IDS) a[id] = WEAPONS[id].ammo;
  return a;
}

/** Munice v deathmatchi: i základní střely dojdou, řízená střela a kamikadze dron nejsou (pilotování by se míjelo se světem). */
export function dmAmmo(shells: number): Record<WeaponId, number> {
  const a = initialAmmo();
  a.shell = shells;
  a.guided = 0;
  a.kamikaze = 0;
  a.bomber = 0;
  return a;
}

/** Kolik výstřelů tank ještě má (−1 = nekonečno). */
export function totalAmmo(ammo: Partial<Record<WeaponId, number>>): number {
  let n = 0;
  for (const id of WEAPON_IDS) {
    const a = ammoOf(ammo, id);
    if (a < 0) return -1;
    n += a;
  }
  return n;
}
